import { Gondor } from "../Gondor";

const ACTIONS = {
  EMAIL: "/email",
};

export function email(body: any) {
  return Gondor.http.post(ACTIONS.EMAIL, body);
}
